<template>

    <div>

        <b-dropdown variant="danger" size="sm" class="d-block testClient">
            <template v-slot:button-content>
                <i class="fa fa-trash"></i> Brisanje<br/>(testni klient)
            </template>
            <template v-slot:button>
                <i class="fa fa-trash"></i> Brisanje<br/>(testni klient)
            </template>

            <b-dropdown-item @click="showDeleteViaRestModal()">Brisanje (REST)</b-dropdown-item>
            <b-dropdown-item @click="showDeleteViaCmisModal()">Brisanje (CMIS)</b-dropdown-item>
        </b-dropdown>


        <b-modal
                centered
                size="lg"
                ref="delete-modal"
                title="Podatki o uporabniku">


            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="false"></loading>

            <div class="row">
                <div class="col-md-12">

                    <div class="form-group">
                        <label for="alfrescoUser">alfrescoUser</label>
                        <input type="text" class="form-control" id="alfrescoUser"
                               aria-describedby="alfrescoPassword"
                               v-model="nodeData.alfrescoUser"

                        />
                    </div>

                    <div class="form-group">
                        <label for="alfrescoPassword">alfrescoPassword</label>
                        <input type="text" class="form-control" id="alfrescoPassword"
                               aria-describedby="alfrescoPassword"
                               v-model="nodeData.alfrescoPassword"

                        />
                    </div>

                    <div v-if="mode === 'cmis'">
                        <div class="form-group">
                            <label for="externalUserType">externalUserType</label>
                            <v-select class="form-control" :options="['up_varnostne_sheme','up_s_certifikatom']"
                                      id="externalUserType"
                                      v-model="nodeData.externalUserType">
                                <span slot="no-options">Ni zadetkov.</span>
                            </v-select>
                        </div>

                        <div class="form-group">
                            <label for="externalUserId">externalUserId</label>
                            <input type="text" class="form-control" id="externalUserId"
                                   aria-describedby="externalUserId"
                                   v-model="nodeData.externalUserId"

                            />
                        </div>

                        <div class="form-group">
                            <label for="externalUserCertId">externalUserCertId</label>
                            <input type="text" class="form-control" id="externalUserCertId"
                                   aria-describedby="externalUserCertId"
                                   v-model="nodeData.externalUserCertId"

                            />
                        </div>

                    </div>
                </div>
            </div>

            <div slot="modal-footer" class="w-100">
                <b-button
                        variant="secondary"
                        class="float-left"
                        @click="$refs['delete-modal'].hide()">
                    Prekliči
                </b-button>

                <b-button
                        variant="danger"
                        class="float-right mr-0"
                        @click="mode === 'cmis' ? deleteViaTestClientCmis() : deleteViaTestClientRest()">
                    <i class="fa fa-trash"></i> Izbriši
                </b-button>
            </div>

        </b-modal>


    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios/index';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';

    export default {
        name: 'DeleteViaTestClient',
        props: ['uuid'],
        components: {
            Loading,
            vSelect
        },
        data() {
            return {
                isLoading: false,
                mode: null,
                nodeData: {
                    alfrescoUser: null,
                    alfrescoPassword: null,
                    externalUserType: null,
                    externalUserId: null,
                    externalUserCertId: null
                }
            }
        },
        mounted() {
            const _this = this;

        },
        methods: {
            showDeleteViaRestModal() {
                const _this = this;
                _this.mode = 'rest';
                _this.$refs['delete-modal'].show();
            },

            showDeleteViaCmisModal() {
                const _this = this;
                _this.mode = 'cmis';
                _this.$refs['delete-modal'].show();
            },

            closeModal() {
                const _this = this;

                if (_this.$refs['delete-modal']) {
                    _this.$refs['delete-modal'].hide();
                }

                _this.mode = null;
            },

            deleteViaTestClientRest() {
                const _this = this;

                _this.isLoading = true;

                let data = {
                    "alfrescoUser": _this.nodeData.alfrescoUser,
                    "alfrescoPassword": _this.nodeData.alfrescoPassword
                };

                axios.post(config.demoVpisnik + _this.uuid + '/RestSDKdelete', data)
                    .then((res) => {
                        _this.closeModal();

                        Vue.$toast.open({
                            message: 'Gradivo uspešno izbrisano.',
                            type: 'success',
                            position: 'top-right'
                        });

                        _this.isLoading = false;
                        _this.$router.go(-1);
                    })
                    .catch((error) => {
                        console.log("error", error);

                        Vue.$toast.open({
                            message: 'Pri brisanju je prišlo do napake!',
                            type: 'error',
                            position: 'top-right'
                        });

                        _this.isLoading = false;
                    });
            },

            deleteViaTestClientCmis() {
                const _this = this;

                _this.isLoading = true;

                let data = {
                    "alfrescoUser": _this.nodeData.alfrescoUser,
                    "alfrescoPassword": _this.nodeData.alfrescoPassword,
                    "externalUserType": _this.nodeData.externalUserType,
                    "externalUserId": _this.nodeData.externalUserId,
                    "externalUserCertId": _this.nodeData.externalUserCertId
                };

                axios.post(config.demoVpisnik + _this.uuid + '/CMISdelete', data)
                    .then((res) => {
                        _this.closeModal();


                        Vue.$toast.open({
                            message: 'Gradivo uspešno izbrisano.',
                            type: 'success',
                            position: 'top-right'
                        });

                        _this.isLoading = false;
                        _this.$router.go(-1);
                    })
                    .catch((error) => {
                        console.log("error", error);

                        Vue.$toast.open({
                            message: 'Pri brisanju je prišlo do napake!',
                            type: 'error',
                            position: 'top-right'
                        });

                        _this.isLoading = false;
                    });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/DeleteViaTestClient.vue